import React from 'react'

import { Button } from '@/components'
import { XClose } from '@/components/Icons'
import { cn } from '@/utils/common'

import { ReportingEvent } from '../../../reporting-events/types'

interface SelectedEventPillsProps {
  selectedEvents: ReportingEvent[]
  disabled?: boolean
  onRemove: (eventId: string) => void
}

/**
 * Component for displaying selected events as removable pills
 */
export const SelectedEventPills: React.FC<SelectedEventPillsProps> = ({
  selectedEvents,
  disabled = false,
  onRemove,
}) => {
  if (selectedEvents.length === 0) {
    return null
  }

  return (
    <div className="flex flex-wrap gap-2">
      {selectedEvents.map((event) => (
        <span
          key={event.id}
          className={cn(
            'inline-flex items-center justify-center pl-[10px] pr-1 py-1 gap-[3px] rounded-md border border-gray-light-300 bg-white border-solid text-gray-light-700',
            'text-sm font-medium max-w-full'
          )}
        >
          <span
            className="truncate max-w-[300px]"
            title={event.reporting_event_name}
          >
            {event.reporting_event_name}
          </span>

          <Button
            variant="text"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              if (!disabled) {
                onRemove(event.id)
              }
            }}
            disabled={disabled}
            className="flex items-center flex-shrink-0 p-0 mt-1 hover:opacity-70 focus:outline-none"
          >
            <XClose width={16} height={16} className="text-gray-light-400" />
          </Button>
        </span>
      ))}
    </div>
  )
}
